<app-card-lg [title]="'Sales'">
  <div *appLoading="(loading$ | async) || (machinesLoading$ | async)"></div>
  @if (!(loading$ | async) && !(machinesLoading$ | async)) {
    @for (sale of (sales$ | async); track sale) {
      <app-sales-list-item [sale]="sale" [machine]="getMachine(sale.machine_id)" [machineId]="machineId"></app-sales-list-item>
    }
  }
</app-card-lg>
